var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61454 1.47711C5.81987 1.17904 6.16554 1 6.53573 1H30.8929C31.3012 1 31.6763 1.21748 31.869 1.56586C32.0616 1.91425 32.0406 2.33697 31.8141 2.66575L27.3855 9.09432C27.1802 9.39239 26.8346 9.57143 26.4643 9.57143H2.10715C1.69883 9.57143 1.32367 9.35395 1.131 9.00557C0.938336 8.65718 0.95946 8.23446 1.18596 7.90568L5.61454 1.47711ZM7.12825 3.14286L4.17587 7.42857H25.8718L28.8241 3.14286H7.12825Z",
    fill: "#8A8CA2",
    stroke: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61454 22.9056C5.81987 22.6078 6.16554 22.4286 6.53573 22.4286H30.8929C31.3012 22.4286 31.6763 22.6461 31.869 22.9945C32.0616 23.343 32.0406 23.7655 31.8141 24.0945L27.3855 30.523C27.1802 30.8209 26.8346 31 26.4643 31H2.10715C1.69883 31 1.32367 30.7826 1.131 30.4341C0.938336 30.0859 0.95946 29.6631 1.18596 29.3342L5.61454 22.9056ZM7.12825 24.5715L4.17587 28.8572H25.8718L28.8241 24.5715H7.12825Z",
    fill: "#8A8CA2",
    stroke: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.61454 19.8087C5.81987 20.1066 6.16554 20.2857 6.53573 20.2857H30.8929C31.3012 20.2857 31.6763 20.0682 31.869 19.7198C32.0616 19.3714 32.0406 18.9488 31.8141 18.6199L27.3855 12.1913C27.1802 11.8934 26.8346 11.7143 26.4643 11.7143H2.10715C1.69883 11.7143 1.32367 11.9318 1.131 12.2802C0.938336 12.6286 0.95946 13.0512 1.18596 13.3801L5.61454 19.8087ZM7.12825 18.1429L4.17587 13.8571H25.8718L28.8241 18.1429H7.12825Z",
    fill: "#8A8CA2",
    stroke: "#F2F2F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolana);
export default __webpack_public_path__ + "static/media/solana.edf443ab2d97f89a6fa567ba04959db2.svg";
export { ForwardRef as ReactComponent };